import { ToastContainer, TypeOptions } from "react-toastify";
import { concatClassnames } from "shared/utils/concatClassnames";

type CustomToastTypeStyles = {
  toastClassName: string;
  bodyClassName: string;
  progressClassName: string;
};

const CUSTOM_TOAST_RECORD: Record<TypeOptions, CustomToastTypeStyles> = {
  success: {
    toastClassName: "gg-bg-green-200",
    bodyClassName: "gg-text-green-800",
    progressClassName: "gg-bg-green-800",
  },
  info: {
    toastClassName: "!gg-bg-grey-200 !gg-font-[inherit]",
    bodyClassName: "!gg-bg-grey-200 gg-text-dark-blue",
    progressClassName: "gg-bg-dark-blue",
  },
  warning: {
    toastClassName: "",
    bodyClassName: "",
    progressClassName: "",
  },
  error: {
    toastClassName: "gg-bg-red-600",
    bodyClassName: "gg-text-red-800",
    progressClassName: "gg-bg-red-800",
  },
  default: {
    toastClassName: "",
    bodyClassName: "",
    progressClassName: "",
  },
};

const CustomToastContainer = () => {
  return (
    <ToastContainer
      position="top-center"
      className={"gg-max-w-5xl gg-font-[inherit]"}
      toastClassName={({ type, defaultClassName }: any) =>
        concatClassnames(
          defaultClassName,
          "gg-py-5 gg-px-4 gg-rounded-sm",
          CUSTOM_TOAST_RECORD[(type || "default") as TypeOptions]
            .toastClassName,
        )
      }
      bodyClassName={({ type, defaultClassName }: any) =>
        concatClassnames(
          defaultClassName,
          CUSTOM_TOAST_RECORD[(type || "default") as TypeOptions].bodyClassName,
        )
      }
      progressClassName={({ type, defaultClassName }: any) =>
        concatClassnames(
          defaultClassName,
          "gg-rounded-sm gg-h-1",
          CUSTOM_TOAST_RECORD[(type || "default") as TypeOptions]
            .progressClassName,
        )
      }
      icon={false}
    />
  );
};
export default CustomToastContainer;
